import { render } from "./daysgroupsPurchase.vue?vue&type=template&id=2930d977&scoped=true"
import script from "./daysgroupsPurchase.vue?vue&type=script&lang=js"
export * from "./daysgroupsPurchase.vue?vue&type=script&lang=js"

import "./daysgroupsPurchase.vue?vue&type=style&index=0&id=2930d977&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2930d977"]])

export default __exports__